// GENERATED FILE (DO NOT MODIFIED THIS!!!)
export const localesMap = {
  ar: { code: "ar", name: "العربية" },
  de: { code: "de", name: "Deutsch" },
  el: { code: "el", name: "Ελληνικά" },
  en: { code: "en", name: "English" },
  es: { code: "es", name: "Español" },
  fr: { code: "fr", name: "Français" },
  he: { code: "he", name: "עברית" },
  hr: { code: "hr", name: "Hrvatski" },
  pl: { code: "pl", name: "Polski" },
  pt: { code: "pt", name: "Português" },
  ro: { code: "ro", name: "Română" },
  ru: { code: "ru", name: "Русский" },
  sq: { code: "sq", name: "Shqip" },
  sr: { code: "sr", name: "Српски" },
  "sr-en": { code: "sr-en", name: "Serbian" },
  tr: { code: "tr", name: "Türkçe" },
  uk: { code: "uk", name: "Українська" },
  zh: { code: "zh", name: "中文" },
};
export type TLocale = keyof typeof localesMap;
